import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Token } from 'types'

import { InfoResponse } from './type'

type State = {
  activeTokens: Array<Token>
  allTokens: Array<Token>
  appData: InfoResponse
  LPTokens: Array<Token>
  tokens: Array<Token>
}

const initialState: State = {
  activeTokens: [],
  allTokens: [],
  appData: {
    chainId: null,
    networks: [],
    operatorAddress: '0x',
    quexSubscriptionId: null,
    ufarmCoreAddress: '0x',
    valueTokens: null,
  },
  LPTokens: [],
  tokens: [],
}

export const sliceAppInfo = createSlice({
  initialState,
  name: 'appInfo',
  reducers: {
    setAppData: (state, { payload }: PayloadAction<Partial<InfoResponse>>) => {
      state.appData = { ...state.appData, ...payload }
    },
    setTokenData: (state, { payload }: PayloadAction<Array<Token>>) => {
      const replacedPayload = payload
        .map((token) => ({
          ...token,
          ticker: token.ticker.replace(/USD₮0/g, 'USDT'),
        }))
        .filter((token) => !token.isSpam)

      const LPTokens = replacedPayload.filter((token) => token.tokenType === 'LP_Token')
      const tokens = replacedPayload.filter((token) => token.tokenType === 'Token')
      const activeTokens = tokens.filter((token) => token.tokenChains[0].isActive)

      state.LPTokens = LPTokens
      state.tokens = tokens
      state.activeTokens = activeTokens
      state.allTokens = replacedPayload
    },
  },
})
export const { setAppData, setTokenData } = sliceAppInfo.actions
